( function ( $ ) {
	const duration = 300;

	$('.indy-block-accordion-header').on( "click", function(e) {
		const wrapper = $(this).parent();
		const content = wrapper.find('.indy-block-accordion-content');

		content.stop(); // stop all prior animations

		// if wrapper is already open -> close only after animation has played
		if (wrapper.attr('open')) {
			e.preventDefault();

			content.slideUp(duration);

			setTimeout(function () {
				wrapper.removeAttr('open');
			}, duration);
		} else {
			// as soon as open state is toggled (contents now visible) -> slideDown animation
			e.preventDefault();
			wrapper.attr('open', true);
			content.hide().slideDown(duration);
		}
	});

	function openAccordionFromHash() {
		const hash = window.location.hash;
		if(!hash) return;

		const wrapper = $(`${hash}.indy-block-accordion`);
		if(wrapper.length === 0) return;

		const content = wrapper.find('.indy-block-accordion-content');
		wrapper.attr('open', true);
		content.show();
	}

	openAccordionFromHash();

	window.addEventListener("popstate", () => {
		openAccordionFromHash();
	});

} )( jQuery );
